<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Staff Register"
                btnTitle="Add New"
                :showAddNew="true"
                @onClickAddNewButton="openStaffRegisterAddModal"
            />
        </div>
        <div class="mt-2 px-2">
          <div class="row">
          <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
            <input
                class="form-control invoice-edit-input  "
                tabindex="1"
                type="number"
                placeholder="Enter Staff Id...."
                v-model="staffId"
            >
          </div>
          <div v-if="false" class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
            <input
                class="form-control invoice-edit-input  "
                tabindex="1"
                type="number"
                placeholder="Enter Generation Level..."
                v-model="generationLevel"
            >
          </div>
          <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1">
          <button
              style="min-width: 64px;"
              @click="onClickToGo"
              class="btn btn-primary btn-block waves-effect waves-float waves-light"
          > Go
          </button>
          </div>
        </div>
        </div>
      <div class="col-12">
        <div class="d-flex justify-content-end px-2">
          <button
              @click="onClickToPrint"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
          >
            Print
          </button>
        </div>
      </div>

        <div class="col-12 px-2 mb-4">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th class="text-center">Staff ID</th>
                  <th class="text-center">Staff Name</th>
                  <th class="text-center">Ref. Name & ID</th>
                  <th class="text-center">Rank Name</th>
                </tr>
                </thead>
                <tbody>
                  <tr
                      v-for="(item, i) in tableItems"
                      :key="item.serial_no + '-' + i"
                      v-on="item.level === 0 ? {} : { click: () => (!item.isExpandedChild ? toggleChildren(item) : goToRedirect(item)) }"
                      :class="[
                        'cursor-pointer',
                        item.isExpandedChild ? 'table-info shadow-sm' : '',
                        item.level == 0 ? 'level-one-row' : '',
                      ]"
                  >
                    <td class="text-center">
                      <span :style="{ paddingLeft: item.isExpandedChild ? '50px' : `${item.level * 20}px` }">
                        <span v-if="hasChildren(item) && !item.isExpandedChild" class="mr-1 text-info">
                          {{ expanded[item.serial_no] ? '▼' : '▸' }}
                        </span>
                          <span
                              v-if="item.isExpandedChild"
                              class="me-1 text-success"
                              role="button"
                              title="Open details"
                          >
                          <i class="fas fa-up-right-from-square"></i>
                        </span>
                        <span>{{ item.serial_no }}</span>
                      </span>
                    </td>
                    <td class="text-center">{{ item.name }}</td>
                    <td class="text-center">
                      {{ item.parent_name }}
                      {{ item.parent_serial_no ? '(' + item.parent_serial_no + ')' : '' }}
                    </td>
                    <td class="text-center">{{ item.incentive_setup_name }}({{ item.incentive_equivalent_designation }})</td>
                  </tr>
                </tbody>
              </table>
              <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

      <AddStaffRegisterModal
          v-if="store.state.isModalOpenTwo"
          :employees="employees"
          :incentiveSetupList="incentiveSetupList.value"
      />

       <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleSdm from "@/services/modules/sdm/sdm";
import { computed } from 'vue';
import handleCompany from "@/services/modules/company";
import staffRegisterPrinter from '@/services/utils/pdf/staffRegisterPrint';
import AddStaffRegisterModal from '@/components/molecule/company/sdm/AddStaffRegisterModal'
import handleContact from '@/services/modules/contact'
import handleHospital from "@/services/modules/hospital";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const expanded = ref({})
const childrenCache = ref({});
const staffRegisterData = ref([]);
const staffId = ref(null);
const generationLevel = ref(null);
const { fetchCompanyInfo } = handleCompany();
let companyInfo = reactive({})
const { exportToPDF } = staffRegisterPrinter();
const employees = reactive([]);
const { fetchContactProfiles } = handleContact()
const incentiveSetupList = [];
const token = computed(() => localStorage.getItem('token'));

const { fetchStaffRegister } = handleSdm()
const { fetchIncentiveSetupList } = handleHospital()

const onClickToGo = () => {
  getStaffRegister();
}
const hasChildren = (item) => {
  if (item.isExpandedChild || item.level == 0) return false
  return true;
};

const goToRedirect = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }
  let query = {
    ...route.query,
    staffId: item.serial_no
  };

  const resolved = router.resolve({
    name: 'staff-register',
    params: param,
    query: query
  });

  window.open(resolved.href, '_blank');
}

const toggleChildren = async (item) => {
  const key   = item.serial_no;
  const index = tableItems.value.findIndex(i => i.serial_no === key);

  if (expanded.value[key]) {
    const count = childrenCache.value[key]?.length || 0;
    count && tableItems.value.splice(index + 1, count);
    expanded.value[key] = false;
    return;
  }

  if (!childrenCache.value[key]) {
    let query = getQuery()
    query += '&staff_id=' + key
    query += '&generation=1'
    const res = await fetchStaffRegister(query);
    if (!res.status) return showError(res.message);

    const children = res.data.filter(child => child.level != 0);
    children.forEach(c => c.isExpandedChild = true);

    childrenCache.value[key] = children;
  }

  tableItems.value.splice(index + 1, 0, ...childrenCache.value[key]);
  expanded.value[key] = true;
};

const openStaffRegisterAddModal = () => {
  store.state.isModalOpenTwo = true
}
async function onClickToPrint() {
  let query = getQuery();
  if (staffId.value) query += '&staff_id=' + staffId.value;

  await fetchStaffRegister(query).then((res) => {
    if (res.status) {
      staffRegisterData.value = res.data
    }
  }).then(() => {
    exportToPDF(companyInfo,staffRegisterData.value)
  }).catch((err) => {
    console.log("Something went wrong");
  });
}

const getStaffRegister = async () => {
    let query = getQuery();
    if (staffId.value) query += '&staff_id=' + staffId.value;
    query += '&generation=1'

    loading.value = true
    tableItems.value = []

    await fetchStaffRegister(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }
        tableItems.value = res.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
    console.log(error);
  });
}

const getQuery = () => {
    return `?company_id=${route.params.companyId}`;
}

const getIncentiveSetupList = async () => {
  let query = `?company_id=${route.params.companyId}`;
  query += '&is_all=true&incentive_type=level'
  loading.value = true
  incentiveSetupList.value = []

  await fetchIncentiveSetupList(query).then(res => {
    if (!res.status){
      return
    }
    incentiveSetupList.value = res.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

onMounted(() => {
  const companyQuery = `?company_id=${route.params.companyId}`
  setCompanyInfo()
    Promise.all([
    fetchContactProfiles(companyQuery + `&type=employee`).then((res) => {
      if(res.status) employees.push(...res.data)
    })
  ])
  getIncentiveSetupList()
  if(route.query.staffId && route.query.staffId != undefined && route.query.staffId != ''){
    staffId.value = route.query.staffId
    getStaffRegister()
  }
});

</script>

<style>
.expanded-row {
  background-color: #e6f2ff;
}
.level-one-row {
  background-color: #bac7d5;
}
</style>
